<div class="auth-broker">
  <div class="col-12 p-0 box-form">
    <ng-template [ngIf]="!isResetPassword && !isForgotPassword">
      <div class="col-12">
        <div class="row">
          <div class="col-12 p-0 title">{{ title }}</div>
          <div class="col-12 p-0">
            <mat-radio-group id="radio-group-login-type" class="btn-radio" [(ngModel)]="multiBrokerloginType"
              name="multiBrokerloginType">
              <mat-radio-button class="radio-button mr-4" *ngFor="let item of multiBrokerTypes" [value]="item.type"
                (change)="selectTypeConnection(item.type)" id="radio-button-{{item.id}}">
                {{ item.description }}
              </mat-radio-button>
            </mat-radio-group>
          </div>
          <div class="col-12 p-0 subtitle">{{ subTitle }}</div>
        </div>
        <form id="form-authForm" class="form-deposit" [formGroup]="authForm" [autocomplete]="off">
          <div class="row" *ngIf="multiBrokerloginType">
            <div class="col-12 p-0">
              <mat-form-field>
                <mat-label>{{ loading && brokeragePartners?.length <=0 ? 'Carregando...' : 'Selecione uma corretora'
                    }}</mat-label>
                    <mat-select panelClass="custom-broker-auth" [(ngModel)]="multiBrokerSelected"
                      (selectionChange)="setConfigMultiBroker(item)" name="multiBrokerSelected"
                      [disabled]="brokeragePartners?.length <= 0" id="select-broker" formControlName="broker">
                      <mat-option class="custom-register-option" *ngFor="let item of brokeragePartners" [value]="item"
                        id="select-broker-{{item.usersBrokerName}}">
                        <img class="imgBroker" src="{{ item.usersBrokerImamge }}"
                          onError="this.src='./assets/images/symbols/INDISPONIVEL.PNG';">
                        {{item.usersBrokerViewName}}
                      </mat-option>
                    </mat-select>
              </mat-form-field>
            </div>
            <div class="col-12 p-0">
              <mat-form-field>
                <mat-label>Usuário</mat-label>
                <input id="username" [ngModel]="model.username" matInput trim formControlName="username" minlength="2"
                  (keypress)="validChar($event)" ondragstart="return false;" ondrop="return false;"
                  [disabled]="!multiBrokerSelected" (keydown.enter)="send()" autocomplete="false">
                <mat-error *ngIf="authForm.controls['username'].hasError('required')">Campo obrigatório</mat-error>
                <mat-error
                  *ngIf="authForm.controls['username'].hasError('invalidName') && !authForm.controls['username'].hasError('required')">
                  Por favor, informe um favorecido valido
                </mat-error>
                <mat-error
                  *ngIf="authForm.controls['username'].hasError('customError') && !authForm.controls['username'].hasError('required')">
                  Parâmetros incorretos
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-12 p-0">
              <mat-form-field>
                <mat-label>Digite sua senha</mat-label>
                <input id="password" [type]="!showpassword ? 'password' : 'text'" [ngModel]="model.password" matInput
                  trim formControlName="password" minlength="2" (keypress)="validChar($event)"
                  ondragstart="return false;" ondrop="return false;" autocomplete="off" (keydown.enter)="send()">
                <span matSuffix class="toggleShow" (click)="togglePassword()">{{ showpassword ? 'ocultar' : 'mostrar'
                  }}</span>
                <mat-error *ngIf="authForm.controls['password'].hasError('required')">Campo obrigatório</mat-error>
                <mat-error
                  *ngIf="authForm.controls['password'].hasError('invalidName') && !authForm.controls['password'].hasError('required')">
                  Por favor, informe um favorecido valido
                </mat-error>
                <mat-error
                  *ngIf="authForm.controls['password'].hasError('customError') && !authForm.controls['password'].hasError('required')">
                  Parâmetros incorretos
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-12 forgotPass">
              <span (click)="showForgotPassword()">esqueci minha senha</span>
            </div>
          </div>
        </form>
      </div>
    </ng-template>
    <ng-template [ngIf]="isResetPassword && !isForgotPassword">
      <div class="col-12 p-0 title">{{ titleExpiredPassword }}</div>
      <div class="col-12 p-0 subtitle">{{ subTitleExpiredPassword }}</div>
      <form id="form-redemption" class="form-deposit" [formGroup]="resetForm">
        <div class="row">
          <div class="col-12 p-0">
            <mat-form-field>
              <mat-label>Nova Senha</mat-label>
              <input id="password" [type]="!showpassword ? 'password' : 'text'" [ngModel]="model.password" matInput trim
                formControlName="password" minlength="2" ondragstart="return false;" ondrop="return false;"
                (keyup)="validatorPassword2(model.password)" (keypress)="validChar($event)" autocomplete="off"
                (keydown.enter)="send()">
              <span matSuffix class="toggleShow" (click)="togglePassword()">{{ showpassword ? 'ocultar' : 'mostrar'
                }}</span>
              <mat-error *ngIf="resetForm.controls['password'].hasError('required')">Campo obrigatório</mat-error>
              <mat-error
                *ngIf="resetForm.controls['password'].hasError('invalidName') && !resetForm.controls['password'].hasError('required')">
                Por favor, informe um favorecido valido
              </mat-error>
              <mat-error
                *ngIf="resetForm.controls['password'].hasError('customError') && !resetForm.controls['password'].hasError('required')">
                Parâmetros incorretos
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-12 p-0">
            <mat-form-field>
              <mat-label>Confirmar Nova Senha</mat-label>
              <input id="newPassword" [type]="!showPasswordConfirm ? 'password' : 'text'" [ngModel]="model.newPassword"
                matInput trim formControlName="newPassword" minlength="2" ondragstart="return false;"
                ondrop="return false;" (keyup)="validatorPassword(model.confirmPassword)" (keypress)="validChar($event)"
                autocomplete="off" (keydown.enter)="send()">
              <span matSuffix class="toggleShow" (click)="togglePasswordConfirm()">
                {{ showPasswordConfirm ? 'ocultar' : 'mostrar' }}</span>
              <mat-error *ngIf="resetForm.controls['newPassword'].hasError('required')">Campo obrigatório</mat-error>
              <mat-error
                *ngIf="resetForm.controls['newPassword'].hasError('invalidName') && !resetForm.controls['newPassword'].hasError('required')">
                Por favor, informe um favorecido valido
              </mat-error>
              <mat-error
                *ngIf="resetForm.controls['newPassword'].hasError('customError') && !resetForm.controls['newPassword'].hasError('required')">
                Parâmetros incorretos
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-12">
            <div class="row complexy-password">
              <div class="col-12 bold">Caracteres permitidos: @$*</div>
              <div class="col-12 bold">Sugestão de senha:</div>
              <div class="col-6 left">
                <div>
                  <mat-icon *ngIf="passwordComplexyLength" svgIcon="success-password"></mat-icon>
                  <mat-icon *ngIf="!passwordComplexyLength" svgIcon="success-password-disable"></mat-icon>
                  <span [ngClass]="{'valid': passwordComplexyLength }">Pelo menos 8 caracteres</span>
                </div>
                <div>
                  <mat-icon *ngIf="passwordComplexyNumber" svgIcon="success-password"></mat-icon>
                  <mat-icon *ngIf="!passwordComplexyNumber" svgIcon="success-password-disable"></mat-icon>
                  <span [ngClass]="{'valid': passwordComplexyNumber }">Use números de 0-9</span>
                </div>
                <div>
                  <mat-icon *ngIf="passwordComplexySpecial" svgIcon="success-password"></mat-icon>
                  <mat-icon *ngIf="!passwordComplexySpecial" svgIcon="success-password-disable"></mat-icon>
                  <span [ngClass]="{'valid': passwordComplexySpecial }">Inclua um caractere especial</span>
                </div>
              </div>
              <div class="col-6 left">
                <div>
                  <mat-icon *ngIf="passwordComplexyLetterDown" svgIcon="success-password"></mat-icon>
                  <mat-icon *ngIf="!passwordComplexyLetterDown" svgIcon="success-password-disable"></mat-icon>
                  <span [ngClass]="{'valid': passwordComplexyLetterDown }">Use letras minúsculas (a-z)</span>
                </div>
                <div>
                  <mat-icon *ngIf="passwordComplexyLetterUp" svgIcon="success-password"></mat-icon>
                  <mat-icon *ngIf="!passwordComplexyLetterUp" svgIcon="success-password-disable"></mat-icon>
                  <span [ngClass]="{'valid': passwordComplexyLetterUp }">Use letras maiúscula (A-Z)</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </ng-template>
    <ng-template [ngIf]="!isResetPassword && isForgotPassword">
      <div class="col-12 title">{{ titleForgotPassword }}</div>
      <div class="col-12 subtitle">{{ subTitleForgotPassword }}</div>
      <form id="form-redemption" class="form-deposit" [formGroup]="forgotForm">
        <div class="row">
          <div class="col-12">
            <mat-form-field>
              <mat-label>E-mail</mat-label>
              <input id="email" type="email" [ngModel]="model.email" matInput trim formControlName="email" minlength="2"
                ondragstart="return false;" ondrop="return false;" autocomplete="off" (keydown.enter)="send()">
              <mat-error *ngIf="forgotForm.controls['email'].hasError('required')">
                Por favor, informe um e-mail valido
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="notification-password mx-0 mt-2 mb-3 row" *ngIf="showNotification"
          [ngClass]="{ 'notification-success': !isNotificationError, 'notification-error': isNotificationError }">
          <div class="col-1 p-0 d-flex align-items-center notification-icon">
            <mat-icon *ngIf="!isNotificationError" svgIcon="circle-success" matSuffix></mat-icon>
            <mat-icon *ngIf="isNotificationError" svgIcon="x-circle" matSuffix></mat-icon>
          </div>
          <div class="col p-0 d-flex align-items-center">
            <span class="notification-text">{{ message }}</span>
          </div>
          <div (click)="isShowingNotification()" class="pointer col-1 p-0 d-flex align-items-center notification-icon">
            <mat-icon matSuffix class="valid">clear</mat-icon>
          </div>
        </div>
      </form>
    </ng-template>
  </div>
  <div class="col-12 p-0 button-submit">
    <div class="button-progress">
      <div id="spinnerDiv" *ngIf="loading" [ngClass]="{ 'fadeIn': loading, 'fadeOut': !loading }" class="animated">
        <mat-spinner class="spinner" diameter="38" color="primary-broker"></mat-spinner>
      </div>
      <button *ngIf="!loading" mat-raised-button color="primary02" class="animated" type="submit" (click)="send()"
        [disabled]="loading || ((isForgotPassword && !isResetPassword && forgotForm.invalid) || (isResetPassword && resetForm.invalid)
          || (!isResetPassword && !isForgotPassword && multiBrokerloginType === 1 && authForm.invalid)
          || (isAuthenticationBroker && multiBrokerloginType === 0 && brokerConnected !== 'SIMULATOR'))"
        id="btn-enter-simulator">
        {{ isResetPassword ? 'ALTERAR' : isForgotPassword ? 'ENVIAR' : 'ENTRAR' }}
      </button>
    </div>
  </div>
</div>
